export default {
    Wait: "少々お待ちください。",
    // モーダルタイトル
    Title: "タイトル",
    InsertTitle:      "新規登録",
    InsertBatchTitle: "一括登録",
    UpdateTitle:      "編集",
    DeleteTitle:      "削除",
    CopyTitle:      "コピー",
    ReadTitle: "閲覧",
    Version: "バージョン",
    ErrorTitle: "エラー内容",
    NewInsert: "新規作成",

    // ボタン
    Insert: "登録",
    Create: "作成",
    Add:    "追加",
    Update: "更新",
    BatchDelete: "一括削除",
    Delete: "削除",
    Cancel: "キャンセル",
    Set:    "設定",
    Check: "確認",
    Upload: "アップロード",
    Submit: "送信",
    CodeSubmit: "認証コード送信",
    Verify: "ユーザー認証",
    ResetPassword: "パスワード再設定",
    LogIn: "ログイン",
    LogGingIn :"ログイン中。。。",
    LogOut :"ログアウト",
    Search: "検索",
    Copy: "コピー",
    Read: "閲覧",
    Close: "閉じる",
    Miss_Inbound: "未着信",
    Save: "保存",
    Insert2: "挿入",
    AdSet: "詳細設定",
    InsertTelNo: "番号追加",
    Back: "戻る",
    Today: "今日",
    KeywordSearch: "ワード検索",
    CategoriesSearch: "通話分類検索",
    CategoriesSearchPlaceholder: "通話分類を入力または選択",
    CategoriesSearchNoOptions: "通話分類を入力してください",
    CategoriesSearchCreateLabel: "を作成する(EnterまたはTabで決定)",

    // 一般項目
    Id:             "ID",
    Control:        "操作",
    Memo:           "メモ",
    CompanyName:    "会社名",
    UnknownCompany: "不明な会社",
    DepartmentName: "拠点名",
    Lang: "言語",
    Text: "テキスト",
    Number: "番号",
    Name: "名前",
    True: "あり",
    False: "なし",
    MailAddress: "メールアドレス",
    PasswordPlaceholder: "英数字混在8文字以上",
    PasswordChange: "パスワード変更",
    PasswordChangeCancel: "パスワード変更をキャンセル",
    Present: "現在",
    Of: "の",


    //時間表示
    Minute: "分",
    Hour: "時間",
    Day: "日",
    Week: "週",
    Month: "ヶ月",
    Year: "年",
    Ago: "前",

    // 特定項目
    AllDepartment: "全拠点",
    AllFloor: "全フロア",
    Audio: "音声",
    AudioInfo: "音声ファイル設定",
    AudioSetting: "音声ファイル設定",
    AudioName: "音声名",
    Auth: "権限",
    AutoCreate:	"自動生成",
    BackNumber: "裏番号",
    Created: "登録日",
    CreatedDateTime: "登録日時",
    DateFormat: "YYYY/MM/DD",
    DateFormatJapanese: "YYYY年 M月 D日",
    DisplayNumber: "表示番号",
    Download: "ダウンロード",
    UserIdLogIn: "ユーザーID",
    EntryUserName: "登録者",
    FirstNameCc: "姓",
    FirstNameKana: "セイ",
    FloorSetting:"フロア設定",
    LastNameCc:	"名",
    LastNameKana: "メイ",
    Modified: "更新日",
    Password: "パスワード",
    PasswordLogIn: "Password",
    PasswordNew: "新パスワード",
    PasswordNewRe: "新パスワード(再入力)",
    PasswordOld: "旧パスワード",
    PasswordRe:	"パスワード(再入力)",
    Telno: "電話番号",
    RequiredTelno: "電話番号（必須）",
    UpdateUserName:	"更新者",
    User: "ユーザー",
    UserInfo: "ユーザー情報",
    UserInsert: "ユーザー登録",
    UserName: "ユーザー名",
    UserNameCc: "ユーザー名 (漢字)",
    UserNameKana: "ユーザー名 (カナ)",
    VerificationCode: "認証コード",
    //デバイス管理
    SerialNumber: "シリアルナンバー",
    LatestActive: "最終アクティブ",
    OwnerUserId: "所有ユーザーID",
    OwnerUserName: "所有ユーザー名",
    DeviceInfo: "デバイス情報",
    ApplicationLog: "アプリケーションログ",

    //アカウント管理
    Information: "情報",
    Item: "項目",
    AccountInfoList: {
        user_id : "ユーザーID",
        name : "名前",
        mail_address : "メールアドレス",
        tel_number : "連絡先電話番号",
        password_change : "パスワード変更",
        sub_users: "サブユーザー",
        recorded_time: "録音音声時間",
        voice_expire: "録音保存期限"
    },
    // 【#541】ユーザー管理のユーザー編集で設定するサブID の作成上限
    SubUserLimit: "サブユーザー作成上限",
    SubUserLimitNote: "件（空欄で既定 {default} 件・最大 {max} 件）",
    AccountSubUserId: "サブユーザーID",
    AccountMemo: "メモ",
    AccountNoChange: "変更なし",
    AccountNoSubUsers: "サブユーザーなし",
    // 【#541】上限はユーザーごとの設定になったため、件数を埋め込む形にする。
    // 呼び出し側で {n} を実際の上限値へ置き換える。
    AccountSubUserExp: "録音音声の再生が可能なサブユーザーを{n}つまで管理できます。",
    AccountSubUserPlus: "サブユーザーを追加",
    AccountSubUserMinus: "サブユーザーを削除",
    AccountSubUserPermission: "権限設定",
    AccountSubUserPermissionRecord: "録音音声",
    AccountSubUserPermissionPlayback: "再生",
    AccountSubUserPermissionDownload: "ダウンロード",
    AccountSubUserPermissionMenu: "RecACEplusメニュー",
    AccountSubUserPermissionRecAceApp: "RecACEplusを使用する",
    AccountSubUserPermissionExtNumber: "許可外線番号",
    AccountSubUserPermissionExtNoRestrict: "制限なし（親ユーザーの全外線番号）",
    AccountSubUserPermissionExtSpecify: "外線番号を指定する",
    AccountRecordedTime2monthAgo: "先々月",
    AccountRecordedTime1monthAgo: "先月",
    AccountRecordedTimeThisMonth: "当月",
    AccountCancelForm: "解約申込",

    // 録音音声一覧
    PlayBack: "録音再生",
    Voice: "録音音声",
    VoiceInfo: "録音音声情報",
    ExternalNumber: "外線番号",
    ExtensionNumber: "内線番号",
    DestTelNumber: "相手先番号",
    AnonymousNumber: "非通知",
    InOutType: "発着信",
    AllType: "全て",
    Incoming: "着信",
    Outgoing: "発信",
    IncomingIcon: "◀",
    OutgoingIcon: "▶",
    NumInfo: "番号情報",
    CallDate: "通話日時",
    CallInfo: "通話情報",
    CallCategory: "通話分類",
    CallAnalysisData: "通話概要",
    ShowAll: "すべて表示",
    ShowLess: "折りたたむ",
    CallOverview: "通話要約",
    BillSec: "通話時間",
    CallCount: "通話件数",
    Word: "ワード",
    Date: "日付",
    StartDate: "開始日",
    StartTime: "開始時間",
    EndTime: "終了時間",
    DateTime: "日時",
    StartDateTime: "開始日時",
    EndDateTime: "終了日時",
    DetailConditions: "詳細条件",
    CustomerAdd: "電話帳登録",
    CustomerEdit: "電話帳更新",
    CustomerDelete: "電話帳削除",
    CustomerName: "顧客名",
    TimeMin: "時分",
    Latest: "最新",
    AudioFileDownload: "音声ファイルダウンロード",
    audio2text: "AI録音文字起こし",
    audio2textComplete: "AI録音文字起こし済み",
    audio2textFailed: "AI録音文字起こしに失敗しました。管理者にお問い合わせください。",
    audio2textWorking: "AI録音文字起こし処理中",
    audio2textNotFound: "AI録音文字起こし内容がありません。",
    audio2textFreeHoursMessage: "AI録音文字起こし無料枠 {0}時間 / {1}時間",
    audio2textFreeHours: "毎月{0}時間の無料枠",
    audio2textCallTimeToAccountMenu: "無料枠超過分は{0}時間ごとに{1}円（税抜）の料金が発生します",
    audio2textCallRecAcePlusFree: "※RecACE plusご利用ユーザーは追加料金無し",
    callTextDownload: "通話テキストダウンロード",
    VoiceRetry: "テキスト化再実行",
    Client: "相手先",
    VocAnalysis: "VoC分析",
    VocAnalysisCreateDescription: "現在の検索条件でVoC分析レポートを作成します。",
    VocAnalysisCreateNoticeHeavy: "※ 大量のデータになるとファイル作成に時間を要します。",
    VocAnalysisCreateNoticeProgress: "※ ダウンロードの進捗はダウンロード履歴より確認できます。",
    VocReport: "Voc分析レポート",
    CsvDownload: "CSVダウンロード",
    Downloading: "ダウンロード中...",

    // VoC分析作成履歴 ステータス表示
    VocStatusCompleted: "完了",
    VocStatusRunning: "作成中",
    VocStatusFailure: "失敗",

    // VoC分析モーダル 表示テキスト
    VocEligibleCallCount: "通話件数",
    VocEligibleCallNote: "※ AI録音文字起こしデータがある通話のみ、VoC分析の対象になります。",


    //ユーザー管理
    OwnDevice: "所有デバイス",
    OtherCount: "他 {count} 件",
    Device: "デバイス",
    UserId: "ユーザーID",
    FamilyName: "姓",
    FirstName:	"名",
    Type: "種別",
    Business: "法人",
    Customer: "個人",
    VoicesExpire: "録音データ保持期限",
    DefaultVoicesExpire: "デフォルト録音保持期限",
    OptionVoicesExpire: "オプション録音保持期限",
    HalfYear: "半年",
    Half: "半",
    Options: "オプション",
    customer_infos: "電話帳機能",

    // 権限管理
    Permission: "権限",
    BasePermissionName: "基本権限",
    PermissionName: "権限名",
    PermissionMemo:"メモ",
    UserCount: "ユーザー数",
    PermissionInfo: "権限情報",
    PermissionFeature: "機能",
    PermissionLevel: "レベル",
    permissionDetail: "権限詳細",
    PermissionContent: "権限内容",
    PermissionScope: "権限範囲",
    PermissionAll: "全権限",
    PermissionRead: "閲覧",
    PermissionCreate: "新規登録",
    PermissionEdit: "編集",
    PermissionDelete: "削除",
    PermissionExport: "出力",
    PermissionPlayback: "録音再生",
    PermissionContentList: {
        Record: "録音一覧",
        User: "ユーザ管理",
        Device: "デバイス管理",
        Permission: "権限管理",
        Category: "通話分類設定",
        ProperNoun: "固有名詞設定",
        PhoneBook: "要約詳細管理",
        AlarmSetting: "アラーム設定",
        NotificationSetting: "外部通知設定",
        VocHistory: "VoC分析作成履歴",
        VocCategory: "VoCカテゴリー設定",
        Partner: "パートナー管理"
    },
    PermissionLevelList: {
        user: "一般",
        company: "会社内",
        system: "システム内"
    },
    chargedOption : "有料オプション",
    callRecordOption : "通話録音オプション",

    Count: "件",
    Times: "回",

    // 通話分類設定
    Content: "内容（最大100文字）",
    CategoryDetail: "通話分類詳細",
    CategoryInfo: "通話分類情報",
    CategoryId: "通話分類ID",
    CategoryImage: "通話分類イメージ",
    BackgroundColor: "背景色",
    TextColor: "文字色",
    Reset: "リセット",

    // 複数通話分類設定
    MultipleTopicTitle: "複数通話分類設定",
    MultipleTopicDescription1: "1件の通話に対して複数の分類を許可する場合は有効にしてください。",
    MultipleTopicDescription2: "複数分類は最大5件まで表示されます。",
    MultipleTopicEnable: "有効にする",

    // 固有名詞設定
    ProperNoun: "固有名詞",
    ProperNounInfo: "固有名詞情報",
    Noun: "名詞",
    NounId: "名詞ID",
    TokenCnt: "トークン数",
    TotalTokens: "総トークン数",
    RegisteredDate: "登録日",

    // 要約詳細管理
    PhoneBook: "要約詳細",
    PhoneBookInfo: "要約詳細情報",
    PhoneBookId: "要約詳細ID",
    LastCall: "最終通話",
    TotalCallCnt: "総通話件数",
    CallHistory: "通話履歴",

    // アラーム設定
    AlarmSetting: "アラーム設定",
    AlarmSettingInfo: "アラーム設定情報",
    AlarmSettingId: "アラーム設定ID",
    AlarmSettingImage: "アラーム設定イメージ",
    AlarmSettingBackgroundColor: "背景色",
    AlarmSettingTextColor: "文字色",

    // 外部通知設定
    NotificationSetting: "外部通知設定",
    NotificationSettingInfo: "外部通知設定情報",
    NotificationSettingId: "外部通知設定ID",
    NotificationSettingImage: "外部通知設定イメージ",
    NotificationSettingBackgroundColor: "背景色",
    NotificationSettingTextColor: "文字色",

    // 外部通知モーダル関連
    ExternalNotification: "外部通知",
    EmailNotification: "メール通知", 
    EnableNotification: "有効にする",
    EmailAddress: "メールアドレス",
    EmailAddressPlaceholder: "メールアドレスを入力してください",
    EmailRegistrationStatus: "メール登録状況",
    VerificationStatus: "認証ステータス",
    Verified: "認証済み",
    Unverified: "未認証",
    EmailAddressRequired: "メールアドレスを入力してください。",

    // アラーム設定モーダル関連
    AllSelection: "全選択",
    CategorySelectionPlaceholder: "アラーム対象のカテゴリを選択してください",
    NoCategoryAvailable: "選択可能なカテゴリがありません",
    CategorySetting: "通話分類設定",
    CallTypeSetting: "発着信設定",

    // VoCカテゴリ関連
    VocCategoryTitle: 'VoCカテゴリ管理',
    VocCategoryName: 'カテゴリ名',
    VocCategoryPromptText: '分析指示内容',
    VocCategoryInfo: 'VoCカテゴリ情報',
    VocAnalysisCategory: 'VoC分析カテゴリー',
    // 電話帳CSV入出力
    PhoneBookImport: "CSVインポート",
    PhoneBookExport: "CSVエクスポート",
    PhoneBookImportTitle: "CSV インポート",
    PhoneBookExportTitle: "CSV エクスポート",

    // インポート設定
    ImportFileSelect: "ファイル選択",
    ImportFileSelectTooltip: "【基本CSVフォーマット】\n名前,メモ,電話番号1\n\n通常は電話番号1のみ入力してください。\n\n【複数電話番号の登録方法】\n1つの名前に複数の電話番号を登録したい場合は、\n電話番号2, 電話番号3...と列を追加してください。\n\n【記載例】\n名前,メモ,電話番号1,電話番号2,電話番号3\n田中企画,重要顧客,090-1234-5678,080-9876-5432,\n山田商店,定期連絡先,03-1234-5678,,",
    ImportFileSelectDragDrop: "CSVファイルをドラッグ＆ドロップするか、クリックして選択してください",
    ImportFileDragDrop: "CSVファイルをドラッグ&ドロップ または",
    ImportFileSelectButton: "ファイルを選択",
    ImportFileFormat: "※ CSV形式のみ対応（UTF-8 / Shift-JIS）",
    ImportFileMultiplePhoneNote: "※ 複数の電話番号を登録する場合は、電話番号2, 電話番号3...と列を追加",
    ImportFileSelected: "選択されたファイル",
    ImportTemplateDownload: "CSVテンプレートはこちらからダウンロードできます",
    ImportTemplateFileName: "電話帳_インポートテンプレート.csv",
    ImportTemplateRequiredHeaders: "※ 名前, 電話番号1ヘッダーは必須です。",
    ImportProcessing: "処理中...",
    ImportResult: "インポート結果",
    CopiedToClipboard: "クリップボードにコピーしました",
    ImportSettings: "インポート設定",
    ImportBasicSettings: "基本設定",
    ImportPhoneNumberLeadingZero: "電話番号の先頭に0がない場合",
    ImportPhoneNumberNoChange: "変更しない",
    ImportPhoneNumberAddZero: "0を付ける",
    ImportInvalidNumberHandling: "投入不可電話番号（形式不正）",
    ImportInvalidNumberExclude: "該当行を除外して投入",
    ImportInvalidNumberAbort: "エラーとしてすべて中止",
    ImportFileDuplicate: "ファイル内の重複データ",
    ImportFileDuplicateTooltip: "同じファイル内に同じ電話番号が複数ある場合は、\n最初に読み込まれた行の名前で登録されます。",
    ImportFileDuplicateExclude: "重複を除外してそれ以外を投入",
    ImportFileDuplicateAbort: "重複があればすべて中止",
    ImportExistingDuplicate: "登録済みデータとの重複",
    ImportExistingDuplicateExclude: "重複を除外してそれ以外を投入",
    ImportExistingDuplicateOverwrite: "重複を上書きして投入",
    ImportExistingDuplicateOverwriteNoPermission: "（連絡先の編集・削除の権限が必要です）",
    ImportExistingDuplicateAbort: "重複があればすべて中止",
    ImportExistingDuplicateTooltip: "「上書きして投入」を選ぶと、重複した電話番号は\n元の連絡先から外れてCSVの名前へ移ります。\n元の連絡先の電話番号が0件になった場合、その連絡先は削除されます。\n「除外してそれ以外を投入」では元の連絡先に残り、\nCSVの名前は残りの電話番号だけで登録されます。",
    ImportPreview: "プレビュー",
    ImportPreviewCount: "%d件のデータ",
    ImportErrorCount: "エラー: %d件の不正な電話番号を検出",
    ImportExecute: "インポート実行",

    // エクスポート設定
    ExportContentSelect: "出力内容の選択",
    ExportBasicInfo: "基本情報",
    ExportBasicInfoName: "名前",
    ExportBasicInfoPhoneNumber: "電話番号",
    ExportBasicInfoMemo: "メモ",
    ExportCallHistory: "通話履歴情報",
    ExportCallHistoryTooltip: "通話履歴情報を含めると、各顧客の最新通話情報や統計データが出力されます。\n基本情報のみ必要な場合はチェックを外してください。",
    ExportCallHistoryLastCall: "最終通話日時",
    ExportCallHistoryTotalCount: "総通話件数",
    ExportSettings: "エクスポート設定",
    ExportEncoding: "文字コード",
    ExportEncodingUtf8: "UTF-8",
    ExportEncodingShiftJIS: "Shift-JIS (Excel用)",
    ExportRange: "出力範囲",
    ExportRangeAll: "すべてのデータ",
    ExportRangeFiltered: "検索・フィルター条件を適用",
    ExportPreview: "プレビュー",
    ExportExecute: "エクスポート",
    ExportFileName: "電話帳リスト",

    // 成功・エラーメッセージ
    PhoneBookImportSuccess: "登録しました。(成功件数：%d)",
    PhoneBookImportResultTitle: "インポート結果内容",
    PhoneBookImportResultMessage: "CSV投入不可なデータがあります。修正後、再度CSV投入処理をしてください。",
    PhoneBookImportResultSuccessCount: "成功行数：%d行",
    // 【#415】行単位（サーバー集計）と番号単位で意味が違うため、文言でも区別する。
    // 成功行数 + 登録失敗行数 + 取り込み対象外行数 = CSVのデータ行数
    PhoneBookImportResultServerFailedCount: "登録失敗行数：%d行",
    PhoneBookImportResultSkippedRowCount: "取り込み対象外行数：%d行",
    PhoneBookImportResultFailedCount: "除外番号数：%d件",
    PhoneBookImportResultCopyButton: "コピー",
    PhoneBookImportResultCloseButton: "閉じる",
    PhoneBookImportResultErrorInvalidFormat: "数字のみで3〜128桁の電話番号を入力してください。",
    PhoneBookImportResultErrorDuplicate: "投入したCSVファイル内の電話番号が重複しています。",
    PhoneBookExportSuccess: "電話帳データをエクスポートしました。",
    PhoneBookExportError: "エクスポート処理中にエラーが発生しました。",

    // 通話分類タグ編集
    CallCategoryEdit: "通話分類編集",
    TagEditSearchPlaceholder: "通話分類を検索",
    TagEditDescription: "通話に付与されている分類タグの追加・削除が可能です。",
    TagEditUpdating: "更新中...",
    TagEditNoCategory: "該当する通話分類が見つからない場合は、通話分類設定より新しいタグを追加のうえ、再度操作をお願いいたします。",

    // 保存に失敗した対象を伝えるときの呼称。共有キーの UserInfo は
    // ja が「ユーザー情報」でこの画面の呼称と揃わないため、専用のキーを持つ
    AccountInfoTitle: "アカウント情報",
    // Issue #289: Account name editing
    AccountExternalNumberDescriptionTitle: "外線番号名称設定",
    AccountExternalNumberDescriptionLabel: "名称",
    AccountExternalNumberDescriptionPlaceholder: "例：営業部",
    AccountExternalNumberNumber: "外線番号",

    // Issue #289: Record search
    ExternalNumberSearchPlaceholder: "外線番号を選択（複数可）",
    ExternalNumberSearchNoOptions: "外線番号が見つかりません",

    // パートナー管理
    PartnerInfo: "パートナー情報",
    PartnerId: "パートナーID",
    PartnerName: "パートナー名",
    PartnerS3BucketName: "S3バケット名",
    PartnerS3BucketNameHint: "英小文字・数字・ハイフン・ドットのみ使用できます（3〜63文字）",
    PartnerDomain: "ドメイン",
    PartnerIdentifier: "識別子",
    PartnerOptions: "オプション",
    PartnerOptionsHint: "JSON形式で入力してください",
    PartnerCreated: "作成日時",
    PartnerModified: "更新日時",
    PartnerDeleteConfirm: "以下のパートナーを削除しますか？",
    PartnerDeleteWarning: "※削除すると元に戻せません。",

    // Issue #443: メールOTPによる多要素認証
    MfaTitle: "二要素認証",
    MfaDescription: "{0} 宛に認証コードを送信しました。",
    MfaCodePlaceholder: "認証コード（6桁）",
    MfaRemainingTime: "有効期限：残り {0}",
    MfaExpired: "認証コードの有効期限が切れました。再送信してください。",
    MfaRemainingAttempts: "入力可能回数：残り {0} 回",
    MfaVerify: "認証",
    MfaVerifying: "認証中。。。",
    MfaResend: "認証コードを再送信",
    MfaResendWait: "再送信可能まで {0} 秒",
    MfaResendRemaining: "再送信可能回数：残り {0} 回",
    MfaBackToLogin: "ログイン画面に戻る",

    // Issue #443: アカウント画面の二要素認証設定
    MfaSettingSubUserTitle: "サブユーザーの二要素認証",
    MfaSettingSubUserMail: "送信先メールアドレス",
    MfaSettingSubUserMailUnset: "未設定の場合は親ユーザーのメールアドレス宛に送信されます。",
    MfaSettingSubUserMailUnsetShort: "未設定（親ユーザー宛）",
    AccountCurrentPassword: "現在のパスワード",
    MfaSettingEnable: "二要素認証を有効にする",
    MfaSettingSubUserAfterSave: "登録後に設定できます",
    AccountExternalNumberDescriptionSummary: "外線番号 {0}件 / 名称設定済み {1}件",
    AccountExternalNumberDescriptionNote: "名称は通話履歴の一覧・検索・CSV に外線番号と一緒に表示されます。部署名などを入力してください。",
    AccountExternalNumberDescriptionSaveNote: "このモーダルには保存ボタンがありません。入力した内容は、閉じたあと画面下部の「確認」→「設定」で保存されます。",
    // 【#586】アカウント管理画面の区分見出し・入力誤りの説明・サブユーザー上限
    AccountSections: {
        basic: "基本情報",
        security: "ログイン・セキュリティ",
        sub_user: "サブユーザー",
        recording: "録音・音声",
        external_number: "外線番号",
    },
    AccountValidationMailInvalid: "メールアドレスの形式が正しくありません。",
    AccountValidationTelInvalid: "電話番号は数字のみ（ハイフン不可）の 10〜11 桁で入力してください。",
    AccountValidationPasswordPolicy: "パスワードは英字と数字を含む8文字以上で入力してください。",
    AccountValidationPasswordRequired: "パスワードを入力してください。",
    AccountValidationCurrentPasswordRequired: "現在のパスワードを入力してください。",
    AccountValidationPasswordMismatch: "新しいパスワードと確認用パスワードが一致しません。",
    AccountValidationSummary: "入力内容に誤りがあります（赤枠の項目を確認してください）",
    AccountSubUserCount: "サブユーザー（{0} / 上限 {1} 件）",
    AccountSubUserLimitReached: "上限に達しているため追加できません。",
    AccountNotSet: "未設定",
    AccountReauthNote: "メールアドレスまたは二要素認証を変更するため、現在のパスワードを入力してください。",
    // 再認証モーダル（「設定」を押したときに出す本人確認）
    AccountReauthModalTitle: "本人確認",
    AccountMfaChangeReauthNote: "二要素認証の設定を変更するには、現在のパスワードの入力が必要です。",
    MfaSettingSubUserMailPlaceholder: "例：sub-user@example.co.jp",
    MfaSettingSubUserMailInvalid: "メールアドレスの形式が正しくありません。",

    // メールアドレス変更時の再認証UI
    // #443 でサーバ側がメールアドレス変更に現在のパスワードを要求するようになったが、
    // 入力欄が「パスワード変更」を開かないと出てこないため、確認ボタンが押せない状態に見えていた。
    AccountMailChangeReauthNote: "メールアドレスを変更するには、現在のパスワードの入力が必要です。",
    AccountMailChangeSubUserNote: "メールアドレスは親ユーザーのみ変更できます。",
    AccountMailChangeMfaNote: "二要素認証が有効です。変更すると、ログイン時の認証コードは新しいメールアドレス宛に送信されます。受信できないアドレスを保存するとログインできなくなるため、入力内容をご確認ください。",

    // Issue #443: ユーザー管理画面の二要素認証
    MfaStatus: "二要素認証",
    MfaStatusOn: "有効",
    MfaStatusOff: "無効",
    // 【#586】アカウント管理の二要素認証の説明
    AccountMfaDescOn: "ログインのたびに {0} へ確認コードを送ります。",
    AccountMfaDescOff: "有効にすると、ログイン時にメールで届く確認コードの入力が必要になります。",
    MfaOffButton: "OFFにする",
    MfaOffTitle: "二要素認証の無効化",
    MfaOffConfirmMessage: "{0} の二要素認証を無効にします。よろしいですか？",
    MfaOffNote: "※管理者が有効にすることはできません。有効化は利用者がアカウント画面から行います。",
    MfaOffPasswordLabel: "ご自身のログインパスワード",
    MfaOffPasswordNote: "二要素認証を外す操作のため、操作するご自身のパスワードの入力が必要です。",
}

